import { render, staticRenderFns } from "./pi-site-steps-record.vue?vue&type=template&id=4b539422&"
import script from "./pi-site-steps-record.vue?vue&type=script&lang=ts&"
export * from "./pi-site-steps-record.vue?vue&type=script&lang=ts&"
import style0 from "./pi-site-steps-record.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports